var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TransferArrowB(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 48h36v4H26v10L14 50l12-12v10zm24-10l12-12-12-12v10H14v4h36v10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Transfer_arrow_B.314b9dcb.svg";
export { SvgJ1TransferArrowB as ReactComponent };